<template>
  <template v-if="dialogState">
  <GDialog
    v-model="dialogState"
    max-width="90%"
    transition="custom-from-bottom-transition"
  >
  <SpotUpdateModalForm
    v-if="!loading"
    v-model="dialogState"
    :item="form"
    :showFlash="showFlash"
    @updateItem="updateItem"
    :label="label"
    :isUpdateAuthority="isCreateAuthority"
    :isOperationOffice="isOperationOffice"
    :isSubManagementOffice="isSubManagementOffice"
    :readOnlyKeys="readOnlyKeys"
    :draggable="draggable"
  />
  </GDialog>
  </template>
  <div class="d-flex align-items-center" @click="dialogState = true">
    <slot name="button" :dialogState="dialogState">
      <v-btn class="exec-btn" >
        {{ i18n.global.t('pages.common.button.newCreate') }}
      </v-btn>
    </slot>
  </div>

</template>

<script>
import 'gitart-vue-dialog/dist/style.css'
import { GDialog } from 'gitart-vue-dialog'
import Buttons from '@/components/SpotParts/ModalButtons'
import SpotUpdateModalForm from '@/components/SpotParts/SpotUpdateModalForm'
import { useAuth } from "@/services/user/Auth0UserProvider"
import i18n from '@/lang/i18n';

export default {
  setup() {
    const { loginWithRedirect } = useAuth();
    return {
      loginWithRedirect,
      i18n
    }
  },
  props: {
    showFlash: {
      type: Function,
    },
    item: {},
    icon: {
      type:String,
      default: 'edit_note',
    },
    label: {
      type: String,
      default: i18n.global.t('pages.spot.form.regist'),
    },
    draggable: {
      type: Boolean,
      default: true
    },
    isCreateAuthority: {
      type: Boolean,
    },
    isOperationOffice: {
      type: Boolean,
      default: false,
    },
    isSubManagementOffice: {
      type: Boolean,
      default: false,
    },
    readOnlyKeys: {
      type: Array,
      default: null
    },
    preMount: {
      type: Function,
      default: (item) => { return item }
    }
  },
  data: () => ({
    dialogState: false,
    form: {},
    loading: true,
  }),
  methods: {
    updateItem(res) {
      this.$emit('updateItem', res)
    }
  },
  watch: {
    dialogState: {
      async handler() {
        if (this.dialogState) {
          this.form = await this.preMount(this.item);
          this.$emit('change', this.form)
        }
        this.loading = false
      }
    }
  },
  components: {
    GDialog,
    SpotUpdateModalForm,
  },
}
</script>

<style>
</style>
